<div *ngFor="let group of pub_group; let year_index = index">
    
    <h5 class="p-3 mb-2 bg-dark text-light">{{group.year}}</h5>
<div class="publication" *ngFor="let pub of group.pubs;  let pub_index = index">
<div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
            <div class="">
                <div >
                    <div class="img-square-wrapper">
                        
                    </div>
                    <div class="">
                        <h4 class="card-title">
                            <span *ngIf="pub.has_award && pub.award_name=='Best Paper'"><i class="fa fa-trophy fa-1x" style="color: goldenrod;"></i></span>
                            <span *ngIf="pub.has_award && pub.award_name=='Honorable Mention'"><i class="fa fa-medal fa-1x" style="color: goldenrod;"></i></span>
                            {{pub.title}}
                            <span *ngIf="pub.has_award && pub.award_name=='Best Paper'">({{pub.award_name}})</span>
                            <span *ngIf="pub.has_award && pub.award_name=='Honorable Mention'">({{pub.award_name}})</span>
                            
                        </h4>
                        <span *ngIf="pub.current_status" class="current_status">
                            <a href="{{pub.conference_url}}" target="_blank">{{pub.current_status}}</a>
                        </span>
                        

                        <p class="card-text">
                            <!-- <br> -->
                            <b>Authors</b>: &nbsp;&nbsp;
                            <span *ngFor="let author of pub.authors_list">
                                    <span [ngClass]="{'author': author==='Sakshi Bhardwaj'}">
                                        {{author}};&nbsp;
                                    </span>
                                
                            </span>
                    
                        </p>
                        <div *ngIf="pub.isPublished ">
                        <a href="{{pub.conference_url}}" target="_black">{{pub.conference_name}} {{pub.year}}</a>
                        
                        </div>
                        
                        
                    <div class="row">
                        <div class="col-md-12">
                            <a  *ngIf="pub.arxiv_link!=null"  href="{{pub.arxiv_link}}" target="_blank" class="btn badge badge-primary pub-buttons">PDF</a>
                    <a *ngIf="pub.doi!=null" href="{{pub.doi}}" target="_blank" class="btn badge badge-primary pub-buttons">DOI</a>
                    <a  *ngIf="pub.bibtex!=null" class=" btn badge badge-primary pub-buttons" (click)="toggleBibtex(year_index, pub_index)">Bibtex</a>

                    <a *ngIf="pub.ppt!=null" href="{{pub.ppt}}" target="_blank" class="btn badge badge-primary pub-buttons">Slides</a>
                    <a *ngIf="pub.poster!=null" href="{{pub.poster}}" target="_blank" class="btn badge badge-primary pub-buttons">Poster</a>
                            <!-- <span class="tags badge badge-info" *ngFor="let tag of pub.tags  ">
                                {{tag}}
                            </span> -->
                    <div class="bibtex" *ngIf="getShowBibtexYearIndex()==year_index  && getShowBibtexPubIndex()==pub_index">
                        <code>{{pub.bibtex}}</code>
                        <!-- <button class="btn btn-outline-dark" (click)="copy(pub.bibtex)">Copy Bibtex</button> -->
                    </div>
                    <a (click)="toggleAbstract(year_index, pub_index)" class="btn badge badge-primary pub-buttons">
                            <span *ngIf="!(getShowAbstractYearIndex()==year_index && getShowAbstractPubIndex()==pub_index)">Show Abstract</span>
                            <span *ngIf="getShowAbstractYearIndex()==year_index && getShowAbstractPubIndex()==pub_index">Hide Abstract</span>
                        </a>
                        <p *ngIf="getShowAbstractYearIndex()==year_index && getShowAbstractPubIndex()==pub_index">
                            {{pub.abstract}}

                        </p>
                            
                        </div>
                        
                    </div>
                    
                        
                    </div>
                </div>
            </div>

            <hr>
        </div>
    </div>
</div>


</div>
</div>
